import Siema from 'siema';

if(document.querySelector('.slider__images')) {
    const slider = new Siema({
        selector: '.slider__images',
        draggable: false,
        duration: 600,
        loop: true,
    });

    setInterval(() => {
        slider.next();
    }, 8000);
}

if(document.querySelector('.slider__scroll-down')) {

    document.querySelector('.slider__scroll-down').addEventListener('click', (e) => {
        e.preventDefault();

        document.querySelector('.intro').scrollIntoView({
            behavior: 'smooth',
        })
    })
}

if(document.querySelector('.news__carousel') && document.querySelectorAll('.news__item').length >= 3) {
    const news = new Siema({
        selector: '.news__carousel',
        draggable: true,
        duration: 250,
        loop: true,
        perPage: {
            480: 1,
            768: 2,
            991: 3,
        },
    });

    document.querySelector('.news__nav-prev').addEventListener('click', () => news.prev());
    document.querySelector('.news__nav-next').addEventListener('click', () => news.next());
}

if(document.querySelector('.search__toggle')) {
    document.querySelector('.search__toggle').addEventListener('click', (e) => {
        e.preventDefault();

        const searchForm = document.querySelector('.search__form');

        if(searchForm.classList.contains('search__form--open')) {
            searchForm.classList.remove('search__form--open');
        } else {
            searchForm.classList.add('search__form--open');
        }
    });
}